import React, { useContext, useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { cancel } from "../../../../assets/icons";
import SmallButton from "../../../../components/button/SmallButton";
import AsyncSelect from "react-select/async";
import ApplyChip from "../../../../helpers/applyChip/ApplyChip";
import PackageListContext from "../../../../store/admin/package_list/PackageListContext";
import { loadPackageList } from "../../../../helpers/loadOption/LoadOption";
import { queryparams } from "../helpers/List";
import SetQueryString from "../../../../helpers/query_searchParams/SetQueryString";
import { useHistory, useLocation } from "react-router-dom";

const PackageListFilter = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const [packages, setPackage] = useState({
    label: "",
    values: "",
  });
  const queryClient = useQueryClient();
  const context = useContext(PackageListContext);
  const { packageListState, packageListDispatch } = context;
  const { filter } = packageListState;

  const handleShowFilter = () => {
    packageListDispatch({ type: "show_filter" });
    packageListDispatch({ type: "reset_filter" });
  };

  const handleChangeFilter = (event: any) => {
    let name = event.target.name;
    let value = event.target.value;
    packageListDispatch({
      type: "handle_filter",
      payload: { ...filter, [name]: value },
    });
    SetQueryString(queryparams, value, name, search, pathname, history);
  };

  const applyFilter = () => {
    queryClient.invalidateQueries("getPackageList");
    ApplyChip(queryparams, packageListDispatch);
    history.push({ pathname, search });
    setTimeout(() => packageListDispatch({ type: "show_filter" }), 1000);
  };

  const handleChangePackage = (pack: any) => {
    setPackage(pack);
    SetQueryString(
      [{ real_name: "name", show_name: "package_name" }],
      pack.label,
      "package_name",
      search,
      pathname,
      history
    );
  };

  useEffect(() => {
    packageListDispatch({
      type: "handle_filter",
      payload: {
        ...filter,
        package_name: packages.label,
      },
    });
  }, [packages]);

  return (
    <div className="fixed z-50 h-screen inset-0 flex justify-center md:items-center items-start bg-black bg-opacity-70">
      <div
        className="bg-white md:rounded-lg rounded-t-none rounded-b-lg overflow-hidden h-3/5 shadow-xl transform transition-all md:max-w-2xl max-w-lg"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div className="px-10 py-7 flex justify-between items-center w-full h-1/5">
          <h1
            className="md:text-2xl text-lg leading-6 font-medium text-inputColor"
            id="modal-headline"
          >
            Filter
          </h1>
          <img
            src={cancel}
            alt="back"
            className="cursor-pointer md:w-5 w-3"
            onClick={handleShowFilter}
          />
        </div>
        <hr className="w-full " />
        <div className="overflow-hidden h-3/5">
          <div className="flex px-10 items-center md:h-1/2">
            <div className="w-full">
              <h1 className="md:text-base text-sm text-inputColor">
                Package Name
              </h1>
              <AsyncSelect
                name="package_name"
                cacheOptions
                defaultOptions
                loadOptions={loadPackageList}
                onChange={handleChangePackage}
                className="my-3.5 font-rom text-sm"
              />
            </div>
          </div>
          <hr className="w-ful " />
          <div className="flex px-10 items-center md:h-1/2">
            <div className="mr-12 w-96">
              <h1 className="md:text-base text-sm text-inputColor">Status</h1>
              <select
                onChange={handleChangeFilter}
                name="status"
                className="md:h-10 h-8 font-rom w-full cursor-pointer rounded-md md:text-sm text-xs my-3 px-3 border-2 border-softGray transition duration-100 ease-in-out shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50"
              >
                <option selected disabled hidden>
                  Select Here
                </option>
                <option value="true">On Selling</option>
                <option value="false">Not Active</option>
              </select>
            </div>
            <div className="w-96">
              <h1 className="md:text-base text-sm text-inputColor">
                Available for
              </h1>
              <select
                onChange={handleChangeFilter}
                name="available_for"
                className="md:h-10 h-8 font-rom w-full cursor-pointer rounded-md md:text-sm text-xs my-3 px-3 border-2 border-softGray transition duration-100 ease-in-out shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50"
              >
                <option selected disabled hidden>
                  Select Here
                </option>
                <option value="0">All Users</option>
                <option value="1">Consignment</option>
                <option value="4">Cosignment VIP</option>
                <option value="2">Gift</option>
                <option value="3">Tester</option>
              </select>
            </div>
          </div>
        </div>

        <hr className="w-full " />
        <div className="flex justify-center items-center h-1/5">
          <SmallButton
            type={"button"}
            color={"bg-softPink"}
            textColor={"text-white"}
            hoverColor={"bg-red-300"}
            handleClick={applyFilter}
            text={"Apply"}
            loadColor={"white"}
          />
        </div>
      </div>
    </div>
  );
};

export default PackageListFilter;
